import {Component, EventEmitter, Output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {IconComponent} from '../icon/icon.component';

@Component({
  selector: 'ucs-sidebar-template',
  imports: [
    IconComponent,
    TranslatePipe
  ],
  templateUrl: './sidebar-template.component.html',
  styleUrl: './sidebar-template.component.scss'
})
export class SidebarTemplateComponent {

  @Output() hideSidebar = new EventEmitter();

  /**
   * Emits to parent component that sidebar is to be hidden
   */
  onToggleSidebar() {
    this.hideSidebar.emit();
  }

}
